export * from '@fhs/routing/src/routes/menu/(menu)/[slug]/customize';
export { default } from '@fhs/routing/src/routes/menu/(menu)/[slug]/customize';
